import { firebase } from '@app/config/fire-conf';
import { StorageImage } from '@app/types/storage-image';
import { CinemaIds } from '@app/types/cinema';
import { DaysOfWeek, ShowtimeSlot, TimeSeconds } from '@app/types';

export type AvailableOn = {
  c1: boolean;
  c2: boolean;
  c3: boolean;
};

export type Cast = {
  uid: string;
  photo?: StorageImage;
  characterName: string;
  castName: string;
};

export type Crew = {
  department: string;
  name: string;
};

export type SpeicalTicketPrice = ShowtimeSlot & {
  dayOfWeek: keyof typeof DaysOfWeek;
};

export type SpecialTicketPrices = {
  cinemaId: keyof typeof CinemaIds;
  prices: SpeicalTicketPrice[];
};

export enum MovieStatus {
  active = 'active',
  comingSoon = 'coming-soon',
  archive = 'archive',
}

export type Movie = {
  id: string;
  slug: string;
  backdrop: StorageImage;
  poster: StorageImage;
  photos: StorageImage[];
  cast: Cast[];
  crew: Crew[];
  status: MovieStatus;
  featured?: boolean;
  genre: string[];
  language: string;
  name: string;
  overview: string;
  releaseDate: firebase.firestore.Timestamp;
  runTime: number;
  tagline?: string;
  trailer: string;
  url?: string;
  premiereDate?: firebase.firestore.Timestamp | false;
  isScheduled: boolean;
  availableOn: AvailableOn;
  specialTicketPrices: SpecialTicketPrices[];
  certification: string;
  lastUpdatedAt: firebase.firestore.Timestamp;
};

export type MovieSingle = Omit<Movie, 'releaseDate' | 'lastUpdatedAt' | 'premiereDate'> & {
  releaseDate: TimeSeconds;
  lastUpdatedAt: TimeSeconds;
  premiereDate?: TimeSeconds | false;
};
